export const BASE_ENDPOINT_PATH = "/sales-api/leads-generator/v2";
export const BASE_ADV_SEARCH_ENDPOINT_PATH = "/sales-api/advanced-search";
